module.exports = __webpack_public_path__ + "static/media/galerija_2019 (22).072d30e7.jpg";